import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLine, Reveal } from "./Reveal";

export const PageHero = ({ overline, lines, copy, testid }) => (
  <section className="relative overflow-hidden pb-16 pt-36 sm:pb-20 sm:pt-44" data-testid={testid}>
    <div className="pointer-events-none absolute -right-40 -top-40 h-[28rem] w-[28rem] rounded-full bg-das-violet/10" />
    <div className="pointer-events-none absolute -left-24 top-64 h-56 w-56 rounded-full bg-das-violet/5" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-das-deep">{overline}</p>
      </Reveal>
      <h1 className="mt-6 font-display text-5xl font-semibold leading-[1.05] tracking-tighter text-das-ink sm:text-6xl lg:text-7xl">
        {lines.map((line, i) => (
          <MaskedLine key={line} delay={0.1 + i * 0.12}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {copy && (
        <Reveal delay={0.35}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-neutral-600 sm:text-lg">{copy}</p>
        </Reveal>
      )}
      <Reveal delay={0.45}>
        <div className="mt-10 h-px w-full bg-neutral-200" />
      </Reveal>
    </div>
  </section>
);

export const CTABand = ({ title = "Let's build your business together.", copy, testid }) => (
  <section className="px-6 py-24 md:px-12" data-testid={testid}>
    <Reveal>
      <div className="grain relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-das-deep px-8 py-20 text-center sm:px-16">
        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-32 -right-16 h-96 w-96 rounded-full bg-black/10" />
        <p className="relative text-xs font-bold uppercase tracking-[0.24em] text-white/70">
          Book a Consultation
        </p>
        <h2 className="relative mx-auto mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl">
          {title}
        </h2>
        {copy && <p className="relative mx-auto mt-5 max-w-xl text-base text-white/75">{copy}</p>}
        <Link
          to="/consultation"
          data-testid="cta-band-button"
          className="group relative mt-10 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 font-display text-base font-semibold text-das-deep transition-transform duration-300 hover:scale-[1.04]"
        >
          Book a Consultation
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
        </Link>
      </div>
    </Reveal>
  </section>
);
